export enum WP_PAGE_ACF_FC_Layouts {
  CURRENTLY = 'currently',
  FREE = 'free',
  SELECTION_SIT = 'selection_sit',
  TEXT_IMAGES = 'text_images',
  EVENEMENTS_SIT = 'evenements_sit',
  CONTEXT = 'context',
  LIST_PAGES = 'list_pages',
  LIST_LINKS = 'list_links',
  NEWSLETTER = 'newsletter',
  BOOKMARKS = 'bookmarks',
  ITINERARY = 'itinerary',
  DEFAULT = 'default',
}
